module.exports = new __parcel__URL__("battlepass_buy_success_background.e4e35640.png").toString();